import React, { useEffect, useMemo, useState } from 'react';
import { ref, onValue, query, orderByChild, equalTo } from 'firebase/database';
import { database } from '../../firebaseConfig';
import { useAuth } from '../../context/AuthContext';
import { useTeam } from './useCrm';
import { ui } from './crmUi';
import { MessagesTable, TYPE_LABEL } from '../../components/MessagesSection';

// Email & Text Log: every email and text Resi sent (crm/messageLog). Admins see all and can filter;
// everyone else sees only messages they sent.
export default function MessagesLogPage() {
  const { user, userRole } = useAuth();
  const isAdmin = userRole === 'Admin';
  const team = useTeam();
  const [rows, setRows] = useState(null);
  const [f, setF] = useState({ agent: '', type: '', channel: '', from: '', to: '', tx: '', q: '' });
  useEffect(() => {
    if (!user?.uid) return undefined;
    const r = isAdmin ? ref(database, 'crm/messageLog') : query(ref(database, 'crm/messageLog'), orderByChild('agentUid'), equalTo(user.uid));
    return onValue(r, (s) => setRows(Object.entries(s.val() || {}).map(([id, v]) => ({ id, ...v })).sort((a, b) => String(b.sentAt).localeCompare(String(a.sentAt)))), () => setRows([]));
  }, [user?.uid, isAdmin]);
  const shown = useMemo(() => (rows || []).filter((m) =>
    (!f.agent || m.agentUid === f.agent) && (!f.type || m.type === f.type) && (!f.channel || (m.channel || 'email') === f.channel)
    && (!f.from || String(m.sentAt).slice(0, 10) >= f.from) && (!f.to || String(m.sentAt).slice(0, 10) <= f.to)
    && (!f.tx || m.transactionId === f.tx.trim())
    && (!f.q || JSON.stringify([m.to, m.subject, m.bodyPreview]).toLowerCase().includes(f.q.toLowerCase()))), [rows, f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const txIds = useMemo(() => [...new Set((rows || []).map((m) => m.transactionId).filter(Boolean))], [rows]);
  return (
    <div style={ui.page}>
      <h1 style={ui.h1}>Email &amp; Text Log</h1>
      <p style={ui.sub}>{isAdmin ? 'Every email and text Resi sent, for review.' : 'Emails and texts you sent from Resi.'} Times are Eastern. Click a row for details.</p>
      <div style={{ ...ui.row, marginBottom: 10 }}>
        <select style={{ ...ui.input, width: 'auto' }} value={f.channel} onChange={set('channel')} aria-label="Channel"><option value="">Email + text</option><option value="email">Email</option><option value="text">Text</option></select>
        <select style={{ ...ui.input, width: 'auto' }} value={f.type} onChange={set('type')} aria-label="Type"><option value="">Any type</option>{Object.entries(TYPE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</select>
        {isAdmin && <select style={{ ...ui.input, width: 'auto' }} value={f.agent} onChange={set('agent')} aria-label="Agent"><option value="">Any agent</option>{team.map((t) => <option key={t.uid} value={t.uid}>{t.name}</option>)}</select>}
        <label style={{ fontSize: 13 }}>From <input type="date" style={{ ...ui.input, width: 'auto' }} value={f.from} onChange={set('from')} /></label>
        <label style={{ fontSize: 13 }}>To <input type="date" style={{ ...ui.input, width: 'auto' }} value={f.to} onChange={set('to')} /></label>
        <select style={{ ...ui.input, width: 'auto' }} value={f.tx} onChange={set('tx')} aria-label="Transaction"><option value="">Any deal</option>{txIds.map((t) => <option key={t} value={t}>{t}</option>)}</select>
        <input style={{ ...ui.input, width: 200 }} placeholder="Search to / subject / text" value={f.q} onChange={set('q')} />
      </div>
      <MessagesTable rows={rows === null ? null : shown} showAgent={isAdmin} />
    </div>
  );
}
